/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import TextField from '@mui/material/TextField';
import { 
  FormControl, 
  InputAdornment,
} from '@mui/material';
import { Formik, FormikProps, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Warning } from '@mui/icons-material';

import MikeButton from '../../components/mike-button';
import mikeSharedTheme from '../../styles/mikeSharedTheme';

const accessLevelMessageStyle = css`
  color: #86A2B3;
  font-size: 14px;
  width: 320px;
  height: 36px;
  left: 16px;
  margin-top: 24px;
  line-height: 18px;
`;

const errorStyle= css`
  color: ${mikeSharedTheme.palette.error.main};
  height: 20px;
`;

interface IProps {
  onAdd: (projectName: string, description: string) => void;
  isAddingProject: boolean;
}

interface IState {
  name: string;
  description: string;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
});

class ProjectCreateForm extends React.Component<IProps, IState> {
  constructor(props: Readonly<IProps>) {
    super(props);
    this.state = { name: '', description: '' };
  }

  protected handleCreate = (values: any) => {
    const { onAdd } = this.props;
    // const project = {} as any
    // project.name = values.name;
    // project.description = values.description;
    onAdd(values.name, values.description);
  };

  public render() {    
    const values = {
      name: this.state.name || '',
      description: this.state.description || '',
    };

    return (
      <Formik
        initialValues={values}
        onSubmit={this.handleCreate}
        validationSchema={validationSchema}
        render={props => this.renderForm(props)}
      />
    );
  }

  protected renderForm = (props: FormikProps<IState>) => {
    const {
      values: { name, description },
      touched,
      errors,    
      handleSubmit,
      handleChange,
      setFieldTouched,
    } = props;
    const change = (param: 'name' | 'description', e: React.ChangeEvent<any>) => {
      e.persist();
      this.setState(({ [param]: (e.target as HTMLInputElement).value } as unknown) as IState);
      handleChange(e);
      setFieldTouched(param, true, false);
    };

    return (
      <FormControl fullWidth style={{ height: '800px' }}>
        <TextField
          id="name"
          name="name"
          label="Name"
          value={name}
          onChange={change.bind(null, 'name')}
          margin="normal"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {touched.name && Boolean(errors.name) ? <Warning color="error" /> : <i />}
              </InputAdornment>
            ),
          }}
        />
        <ErrorMessage component="div" name="name" css={errorStyle} />
        <TextField
          id="description"
          name="description"
          label="Description"
          value={description}
          onChange={change.bind(null, 'description')}
          margin="normal"
          fullWidth
        />
        <div css={accessLevelMessageStyle}>
          Projects created here will be shared. Change access rights in Data Admin
        </div>
        <MikeButton
          style={{
            height: '48px',
            top: '24px',
            width: '300px',
          }}
          color="secondary"
          variant="contained"
          onClick={() => handleSubmit()}>
          Create
        </MikeButton>
      </FormControl>
    );
  };
}

export default ProjectCreateForm;
